module.exports = __webpack_public_path__ + "static/media/probitLight.21b31f52.png";